// MSAL imports
import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
        redirectUri: getRedirectUri(),
    },
};

function getRedirectUri() {
    const currentUrl = window.location.href;
    if (currentUrl.includes("localhost")) {
        return "http://localhost:3000"; // Use localhost for local development
    } else if (currentUrl.includes("https://uat.cmiappcenter.nielseniq.io/")) {
        return "https://uat.cmiappcenter.nielseniq.io/"; // Use UAT environment redirect URI
    } else if (currentUrl.includes("https://cmiappcenter.nielseniq.cn/")) {
        return "https://cmiappcenter.nielseniq.cn/"; // Use China production environment redirect URI
    } else {
        // Default to UAT environment if no match
        return "https://uat.cmiappcenter.nielseniq.io/";
        // Alternative: return "http://localhost:3000";
    }
}
export const msalInstance = new PublicClientApplication(msalConfig);